import React from 'react';
import Fade from '@material-ui/core/Fade';
import AmountsPage from './Pages/AmountsPage';
import MoreInfoPage from './Pages/MoreInfoPage';

function App({config}) {
   

    let state = {
        page: 2,
    };

    let nextStep = () => { this.setState({ page: this.state.page + 1 }); }
    let prevStep = () => { this.setState({ page: this.state.page - 1 }); }

    return (
        <div>
            { config && 
                <Fade in={true} timeout={1500} >
                    <div className={`mam-workspace`} elevation={8}>
                        <div className={`mam-title`}>
                            {config.title}
                        </div>
                        <div>
                            {state.page === 2 && <AmountsPage config={config} onNext={nextStep} onBack={prevStep} />}
                            {state.page === 4 && <MoreInfoPage config={config} onNext={nextStep} onBack={prevStep} />}
                        </div>
                    </div>
                </Fade>
            }
        </div>
    )
}


export default App;